import { updateSectionData } from '../../handlers/utils';
import { runAxios } from '../../handlers/axios';
import { onSubmit } from '../../handlers';
import { getUsefulVars } from '../../handlers/helpers';

export const addResume = (props, secPart) => {
  const uv = getUsefulVars(props);
  const jobSeekerData = uv.formikProps.values.jobSeekerData;
  const newResumeIndex = uv.stateProps.dataToSave.saved.resumes.length;
  updateSectionData({ resumeIndex: newResumeIndex, industryType: 'other' }, uv.stateProps);

  const newPartJS = JSON.stringify(secPart);
  const newData = uv.stateProps.dataToSave;
  const newPart = JSON.parse(newPartJS);
  newData.saved.resumes[newResumeIndex] = newPart;
  jobSeekerData[newResumeIndex] = newPart;
  const currentTime = new Date();
  const isoTime = currentTime.toISOString();
  newData.saved.resumes[newResumeIndex]['resume_date'] = isoTime;
  jobSeekerData[newResumeIndex]['resume_date'] = isoTime;
  if (typeof newData.saved.resumes[0]['version'] !== 'undefined') {
    newData.saved.resumes[newResumeIndex]['version'] = newData.saved.resumes[0]['version'];
  }
  if (typeof newData.saved.resumes[0]['contact'] !== 'undefined') {
    newData.saved.resumes[newResumeIndex]['contact'] = [...newData.saved.resumes[0]['contact']];
  }
  uv.stateProps.setDataToSave(newData);
  uv.stateProps.isDataSaved(true);
  uv.stateProps.setEditableIndex(newResumeIndex);
  uv.stateProps.setStep(0);
  onSubmit(uv.formikProps, uv.stateProps);

};
export const checkSummaryOpen = (props) => {
  if (typeof props.stateProps.dataToSave.saved.resumes[0].job_title === 'undefined') {
    props.stateProps.setResumeOpen(true);
  }
};
export const openJobPosting = (id) => {
  const jobPosting = document.querySelector('#'+ id);
  if (jobPosting.style.display !== 'block') {
    jobPosting.style.display = 'block';
  } else {
    jobPosting.style.display = 'none';
  }
}
export const getIndustryCallback = (result, args) => {

  const stateProps = args.props.stateProps;

  stateProps.setAIIndustryData({ aiIndustryQObj: result.data });
  stateProps.setSpinnerImage('default.gif');
  stateProps.setSpinnerMessage('');
  stateProps.onSpinnerClose();
  stateProps.onJobIndustryOpen();
};
export const getIndustry = (props, resumeIndex) => {
  const uv = getUsefulVars(props);

  const jobSeekerData = props.formikProps.values.jobSeekerData;
  const job_title = jobSeekerData[resumeIndex].job_title;
  const url = props.stateProps.domain + '/wp-json/rsworks/v1/ai_industries';
  const request = {
    jobTitle: job_title,
  };
  const args = {
    props: props,
    message: 'Get Industries from AI',
  };
  if (job_title !== props.stateProps.dataToSave.saved.prevJobTitle) {
    props.stateProps.setSpinnerMessage('');
    props.stateProps.setSpinnerImage('default.gif');
    props.stateProps.onSpinnerOpen();
    runAxios(url, request, getIndustryCallback, args);
  } else {
    args.props.stateProps.onJobIndustryOpen();
  }

  props.stateProps.dataToSave.saved.prevJobTitle = job_title;
};